import React,{useState} from 'react'
import Button from 'react-bootstrap/Button'
import Spinner from 'react-bootstrap/Spinner'
import Popover from 'react-bootstrap/Popover'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import ButtonGroup from 'react-bootstrap/ButtonGroup'

const PortionOptions = props =>{
	const completedOptions = [
		{
			text:'1/4',
			amount:1/4
		},{
			text:'1/3',
			amount:1/3
		},{
			text:'1/2',
			amount:1/2
		},{
			text:'2/3',
			amount:2/3
		},{
			text:'3/4',
			amount:3/4
		},{
			text:'1',
			amount:1
		},
	]
	return (
		<OverlayTrigger rootClose trigger="click" overlay={
			<Popover>
				<Popover.Content>
					<ButtonGroup>
						{completedOptions.map(opt=>(
							<Button disabled={props.disabled} onClick={()=>{
								props.onPortionSelect(opt.amount)
							}} variant="outline-primary" size="sm">{opt.text}</Button>
						))}
					</ButtonGroup>
				</Popover.Content>
			</Popover>
		}>
			{props.children}
		</OverlayTrigger>
	)
}

export default PortionOptions